import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <ScrollToTopOnNavigate />
      <SiteHeader />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}

export default SiteLayout;